import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";

type Parameter = {
    downloadtearsheet: boolean;
};

export const DispatchSetDownloadTearSheet: CustomApiHandler<Parameter, boolean> = props => {
    props.dispatch({
        type: "Custom/ProductList/SetDownloadTearsheet",
        result: props.parameter.downloadtearsheet,
    });
};

export const chain = [DispatchSetDownloadTearSheet];

const tearSheetDownload = createHandlerChainRunner(chain, "tearSheetDownload");
export default tearSheetDownload;
